export default "__VITE_ASSET__DekJIKOp__"